import PropTypes from 'prop-types';
import { Button } from '@celltrak/ui-components';
import noop from 'lodash/noop';

import { text } from '../../constants';

const SaveButton = ({ onClick, disabled }) => (
  <Button
    id={text.save}
    onClick={onClick}
    color="primary"
    size={text.mediumSize}
    disabled={disabled}
  >
    {text.save}
  </Button>
);

SaveButton.propTypes = {
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};

SaveButton.defaultProps = {
  onClick: noop,
  disabled: false,
};

export default SaveButton;
